import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import api from "../lib/api";

const TYPE = { invoice: "Invoice", uchanti: "Without invoice", company_vehicle: "Company vehicle", foc: "FOC (free of cost)", no_work: "No work done", outside_work: "Outside work", employee: "Employee gate pass", trial: "Trial" };
const STATUS = { issued: ["INSIDE · show QR at gate", "bg-amber-100 text-amber-800"], out: ["VEHICLE OUT", "bg-green-100 text-green-800"], cancelled: ["CANCELLED", "bg-gray-200 text-gray-700"] };

export default function PublicGatePass() {
  const { token } = useParams();
  const [g, setG] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/gatepass/${token}`).then((r) => setG(r.data)).catch(() => setErr("Gate pass not found"));
  }, [token]);
  if (err) return <div data-testid="public-gp-error" className="min-h-screen grid place-items-center text-sm text-gray-600">{err}</div>;
  if (!g) return <div className="min-h-screen grid place-items-center text-sm text-gray-500">Loading…</div>;
  const [st, cls] = STATUS[g.status] || STATUS.issued;
  return (
    <div data-testid="public-gp" className="min-h-screen bg-gray-50 flex justify-center p-4">
      <div className="w-full max-w-sm bg-white rounded-xl shadow p-5 space-y-4">
        <div>
          <div className="text-xs text-gray-500">{g.workshop}</div>
          <h1 className="text-2xl font-bold">Gate Pass {g.number}</h1>
        </div>
        <div className="flex justify-center"><QRCodeSVG data-testid="public-gp-qr" value={g.qr} size={240} level="Q" fgColor="#000000" bgColor="#FFFFFF" marginSize={2} /></div>
        <div className="text-center"><span data-testid="public-gp-status" className={`text-xs font-bold px-2.5 py-1 rounded-full ${cls}`}>{st}</span></div>
        <div className="text-sm divide-y divide-dashed">
          {[["Vehicle", g.vehicle_number], ["Driver", g.driver_name], ["Date", g.date], ["Type", TYPE[g.gp_type]], ["To", g.to_location], ["Confirmed by", g.verify_method === "staff" ? "" : g.verify_method === "signature" ? "Signature" : "OTP"]]
            .filter(([, v]) => v).map(([k, v]) => <div key={k} className="flex justify-between py-1.5"><span className="text-gray-500">{k}</span><span className="font-medium">{v}</span></div>)}
        </div>
      </div>
    </div>
  );
}
